import { resolveFlyPayReturnBridgeUrl } from '~/utils/flypayPayment.js'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return
  const target = resolveFlyPayReturnBridgeUrl(
    new URL(to.fullPath, window.location.origin).toString(),
    useRuntimeConfig().public.flypayReturnRouting,
  )
  if (target) return navigateTo(target, { external: true, replace: true })
})
